export default "__VITE_ASSET__596c2699__"